<dx-popup #popup [width]="'80%'" [height]="'90%'" [showTitle]="true"[dragEnabled]="false"
    [closeOnOutsideClick]="false" [showCloseButton]="true" container=".dx-viewport" [(visible)]="psrReviewPopupVisible"
    titleTemplate="titleTemplate">
    <div *dxTemplate="let data of 'titleTemplate'" >
        <div class="flex items-center justify-between" style="height: 40px;">
            <div>
                <h4 class="b">Preview PSR Report</h4>
            </div>
            <div>
                <dx-button class="mr2" text="Send for Approval" (onClick)="sendReport($event)" [visible]="showSendReportButton" ></dx-button>
                <span id="link1" class="fa fa-close fa-lg hover-active pointer relative" (click)="closePopup($event)"></span>
            </div>
            
        </div>
    </div>
    <div *dxTemplate="let data of 'content'">
        <div *ngIf="fileName == 'Budget'" class="h-100 w-100">
            <!DOCTYPE>
            <html lang="en">

            <head>
                <title>PDF</title>
            </head>

            <body>
                <object data="/api/pdf/SampleReportWithSingleTitle -Budget-2.pdf" type="application/pdf"
                    style="width: 100%; height: 100%;">
                    <div>No online PDF viewer installed</div>
                </object>
            </body>

            </html>
        </div>
        <div *ngIf="fileName == 'PSR'" class="h-100 w-100">
            <div class="flex items-center w-100 pb3">
                <div *ngIf="weekendingDate" class="flex items-center mr4">
                    <div class="pr1 b">Weekending Date: </div><div class="bb">{{weekendingDate|date}}</div>
                </div>
                <div class="flex items-center mr3">
                    <div *ngIf="productionStatus" class="mr4"><span class="pr1 b">Production Status: </span><span class="bb">{{productionStatus}}</span></div>
                    <div *ngIf="productionStudio" class="mr4"><span class="pr1 b">Production Studio: </span><span class="bb">{{productionStudio}}</span></div>
                </div>
                <div *ngIf="selectedTitles" class="flex items-center mr4">
                    <div class="pr1 b">Selected Titles: </div><div class="bb">{{selectedTitles}}</div>
                </div>
            </div>
            <!DOCTYPE>
            <html lang="en">

            <head>
                <title>PDF</title>
            </head>

            <body>
                <object data="/api/pdf/SampleReportWithTWOTitle PSR-2.pdf" type="application/pdf"
                    style="width: 100%; height: 100%;">
                    <div>No online PDF viewer installed</div>
                </object>
            </body>

            </html>
            <dx-toast [visible]="isToastVisible" type="success" [displayTime]="4000" message="Report send for approval." (onHidden)="onHidden($event)"></dx-toast>
        </div>
    </div>
</dx-popup>